module.exports = __webpack_public_path__ + "img/W7036-mod.5abf6903.jpg";